import http from "@/settings/apiSettings"
class UserDataService {
    getUsersNotAdded(): Promise<any> {
        return http.clientAuth.get("/auth/GetUsersNotAdded");
      }
    }

export default new UserDataService();